<template>
  <section
    class="relative py-16 px-4 md:px-8 lg:px-16 bg-cover bg-center text-white overflow-hidden"
    :style="{ backgroundImage: `url('/images/principles-bg.jpg')` }"
  >
    <!-- Overlay -->
    <div class="absolute inset-0 bg-gray-900 bg-opacity-70"></div>

    <div class="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div
        v-for="(person, index) in themeStore.theme.Principle"
        :key="index"
        class="flex flex-col md:flex-row items-center md:items-start gap-6 p-6 rounded-lg"
      >
        <!-- Image with Border -->
        <div
          class="flex-shrink-0 w-48 h-48 md:w-64 md:h-64 rounded-md overflow-hidden flex items-center justify-center"
          :style="{ border: `4px solid ${person.borderColor}` }"
        >
          <img :src="person.image" :alt="person.name" class="w-full h-full object-cover" />
        </div>

        <!-- Text Content -->
        <div class="text-center md:text-left mt-4 md:mt-0">
          <p class="text-lg font-light mb-1">{{ person.title }}</p>
          <h3 class=" text-2xl md:text-3xl font-bold mb-4">{{ person.name }}</h3>
          <button
            class="bg-[#FDB813] cursor-pointer text-gray-900 px-6 py-3 rounded-full font-semibold hover:bg-opacity-80 transition-all duration-300 flex items-center justify-center mx-auto md:mx-0"
          >
            READ MORE <ArrowRight class="ml-2 h-5 w-5 cursor-pointer" />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const themeStore = useThemeStore();
import { ArrowRight } from 'lucide-vue-next';
import { useThemeStore } from '../../stores/themeStore';
import index from '@/dashbaord/index.vue'
import Principle from '@/website/components/Principle.vue'

</script>

<style scoped>
/* No specific scoped styles needed as Tailwind handles most of it */
</style>
